import axios from 'axios';
import i18n from '@/i18n';
import { tokenService } from '@/services/external/storage';

// Create Axios Instance
const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL || 'https://api.tunistravels.com/api',
    withCredentials: true, // Important for Sanctum cookie-based auth
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Request Interceptor
api.interceptors.request.use((config) => {
    // Check if we are in admin domain to inject admin token
    const isDashboard = window.location.hostname.startsWith('admin.') ||
        window.location.hostname.startsWith('dashboard.') ||
        (window.location.pathname.startsWith('/admin') && import.meta.env.DEV);

    if (isDashboard) {
        const adminAuthStr = localStorage.getItem('tt_admin_auth');
        if (adminAuthStr) {
            try {
                const adminAuth = JSON.parse(adminAuthStr);
                if (adminAuth.token) {
                    config.headers.Authorization = `Bearer ${adminAuth.token}`;
                }
            } catch (e) {
                // Invalid JSON, ignore
            }
        }
    } else {
        // Public / Customer Auth
        const token = tokenService.getAccessToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }

    // Inject Locale for Public/Admin requests
    if (i18n.language) {
        config.headers['X-Locale'] = i18n.language;
    }

    return config;
});

// Response Interceptor
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            const isDashboard = window.location.hostname.startsWith('admin.') ||
                window.location.hostname.startsWith('dashboard.') ||
                window.location.pathname.startsWith('/admin');

            if (isDashboard) {
                // Clear only admin tokens — never touch the public user session
                localStorage.removeItem('tt_admin_auth');
                if (!window.location.pathname.includes('/login')) {
                    window.location.href = '/admin/login';
                }
            } else {
                // Clear public user tokens
                tokenService.clearTokens();
                if (!window.location.pathname.includes('/login')) {
                    window.location.href = '/?login=true';
                }
            }
        }
        return Promise.reject(error);
    }
);


export default api;
